import { Star } from "lucide-react";

export function StarRating({ value = 0, onChange, size = 8, readOnly = false, testid }) {
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          type="button"
          key={n}
          disabled={readOnly}
          onClick={() => onChange && onChange(n)}
          data-testid={testid ? `${testid}-star-${n}` : undefined}
          className={`${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"} transition-transform`}
          aria-label={`${n} stelle`}
        >
          <Star
            className={`w-${size} h-${size} ${
              n <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"
            }`}
          />
        </button>
      ))}
    </div>
  );
}
